/* eslint-disable no-underscore-dangle */
import { completeTypes, createTypes, withPostFailure, withPostSuccess } from 'redux-recompose';
import { push } from 'connected-react-router';

import * as ChecklistsService from '#services/ChecklistsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';
import { ROUTES } from '#constants/routes';

import { CHECKLISTS_TARGETS } from './constants';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['CREATE_CHECKLIST', 'GET_ALL_CHECKLISTS', 'EDIT_CHECKLIST', 'DELETE_CHECKLIST'],
    ignoredActions: ['SET_CURRENT_CHECKLIST']
  }),
  '@@CHECKLISTS'
);

export const actionCreators = {
  createChecklist: values => ({
    type: actions.CREATE_CHECKLIST,
    target: CHECKLISTS_TARGETS.CREATE_CHECKLIST,
    payload: values,
    service: ChecklistsService.createChecklist,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.setCurrentChecklist(null));
        dispatch(actionCreators.getAllChecklists(values?.checklistType));
        dispatch(ModalActions.closeModal(MODALS.NEW_CHECKLIST));
      }),
      withPostFailure(dispatch => {
        dispatch(push(ROUTES.ERROR.path));
      })
    ]
  }),
  getAllChecklists: type => ({
    type: actions.GET_ALL_CHECKLISTS,
    target: CHECKLISTS_TARGETS.CHECKLISTS,
    payload: type,
    service: ChecklistsService.getAllChecklists,
    injections: [
      withPostFailure(dispatch => {
        dispatch(push(ROUTES.ERROR.path));
      })
    ]
  }),
  setCurrentChecklist: payload => ({
    type: actions.SET_CURRENT_CHECKLIST,
    target: CHECKLISTS_TARGETS.CURRENT_CHECKLIST,
    payload
  }),
  editChecklist: values => ({
    type: actions.EDIT_CHECKLIST,
    target: CHECKLISTS_TARGETS.EDIT_CHECKLIST,
    payload: values,
    service: ChecklistsService.editChecklist,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.setCurrentChecklist(null));
        dispatch(actionCreators.getAllChecklists(values?.checklistType));
        dispatch(ModalActions.closeModal(MODALS.NEW_CHECKLIST));
      }),
      withPostFailure(dispatch => {
        dispatch(push(ROUTES.ERROR.path));
      })
    ]
  }),
  deleteChecklist: values => ({
    type: actions.DELETE_CHECKLIST,
    target: CHECKLISTS_TARGETS.DELETE_CHECKLIST,
    payload: values?._id,
    service: ChecklistsService.deleteChecklist,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.setCurrentChecklist(null));
        dispatch(actionCreators.getAllChecklists(values?.checklistType));
        dispatch(ModalActions.closeModal(MODALS.DELETE_CHECKLIST));
      }),
      withPostFailure(dispatch => {
        dispatch(push(ROUTES.ERROR.path));
      })
    ]
  })
};

export default actionCreators;
